import { useMutation } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { FLIGHTS_HOLD_RESERVATION } from '../mutations';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { holdFlight: bffResponse };
}

export default function useHoldFlight(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useMutation(FLIGHTS_HOLD_RESERVATION, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables: { correlationID, hashKey, bookingID, guests } = {} } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/hold',
        body: { correlationID, hashKey, bookingID, guests },
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
